import ReactGA from 'react-ga4'
import { getCookieConsentValue } from '../components/CookieConsent'

const hasConsent = () =>
  getCookieConsentValue('corpstage_cookie_consent') === 'true'

export const trackEvent = (category, action, label = '') => {
  if (!hasConsent()) return
  ReactGA.event({ category, action, label })
}

// Specific event helpers — import these in components
export const trackDemoClick = (page) =>
  trackEvent('Conversion', 'book_demo_click', page)

export const trackEnrolClick = (courseCode) =>
  trackEvent('Academy', 'enrol_click', courseCode)

export const trackIRISStart = () =>
  trackEvent('IRIS', 'conversation_started', '')

export const trackCalculatorLoad = () =>
  trackEvent('Tools', 'calculator_used', 'ESG Capital Advantage Calculator')

export const trackDiagnosticLoad = () =>
  trackEvent('Tools', 'diagnostic_used', 'ESG Operating Model Diagnostic')

export const trackPlatformClick = (platform) =>
  trackEvent('Platform', 'app_link_click', platform)
  // Call with: trackPlatformClick('corpstage.app')
  // or: trackPlatformClick('aivara.corpstage.app')

export const trackContactSubmit = () =>
  trackEvent('Conversion', 'contact_form_submit', '')

export const trackInsightRead = (slug) =>
  trackEvent('Content', 'article_read', slug)

export const trackMasterclassRegister = (title) =>
  trackEvent('Academy', 'masterclass_register_click', title)
